import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { IAuthMetadata } from '../types/auth/authMetadata';

export interface IFetchAppMetadata {
  metadata: IAuthMetadata | undefined;
  isLoadingMetadata: boolean;
}

/**
 * Hook to retrieve Auth0 idToken and decode the app_metadata to retrieve the
 * (document) codes and groupIds
 *
 * @returns IFetchAppMetadata
 */
const useFetchAuthMetadata = (): IFetchAppMetadata => {
  const [metadata, setMetadata] = useState<IAuthMetadata>();
  const [isLoadingMetadata, setIsLoadingMetadata] = useState<boolean>(true);

  const {
    isAuthenticated,
    isLoading: auth0IsLoading,
    getIdTokenClaims,
  } = useAuth0();

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        if (isAuthenticated && !auth0IsLoading) {
          const idTokenClaims = await getIdTokenClaims();
          const namespace = 'com.ingleinternational';
          const appMetaData: IAuthMetadata =
            idTokenClaims?.[namespace + 'app_metadata'] || '';

          setMetadata(appMetaData);
          setIsLoadingMetadata(false);
        } else if (!isAuthenticated && !auth0IsLoading) {
          // If user is not authenticated and auth is done loading,
          // we can finish metadata loading too
          setIsLoadingMetadata(false);
        }
      } catch (error) {
        console.error(error);
        setIsLoadingMetadata(false);
      }
    };

    fetchMetadata();
  }, [isAuthenticated, auth0IsLoading, getIdTokenClaims]);

  return { metadata, isLoadingMetadata };
};

export default useFetchAuthMetadata;
